import { Text } from "@meditect/medibase-components";

export const SalesCannotEditStockItemPriceBecauseStockItemIsOnOpenInventoryError = () => {
  return <Text>Le prix de vente ne peut pas être modifié car le produit est en cours d'inventaire</Text>;
};
